import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from './private/Dashboard/Dashboard';
import Emails from './private/Emails/Emails';
import Feedback from './private/Feedback/Feedback';
import Logs from './private/Logs/Logs';
import Plans from './private/Plans/Plans';
import Settings from './private/Settings/Settings';
import Symbols from './private/Symbols/Symbols';
import TelegramChat from './private/Users/TelegramChat';
import UpgradeRequests from './private/UpgradeRequests/UpgradeRequests';
import Users from './private/Users/Users';
import Login from './public/Login/Login';
import { getToken } from './services/tokenStore';

function Router() {
    function PrivateRoute({ children }) {
        const isAuth = getToken() !== null;
        return isAuth ? children : <Navigate to="/" />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Login />} />
                <Route
                    path="/settings"
                    element={
                        <PrivateRoute>
                            <Settings />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/symbols"
                    element={
                        <PrivateRoute>
                            <Symbols />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/logs"
                    element={
                        <PrivateRoute>
                            <Logs />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <PrivateRoute>
                            <Users />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/plans"
                    element={
                        <PrivateRoute>
                            <Plans />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/upgrade-requests"
                    element={
                        <PrivateRoute>
                            <UpgradeRequests />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/emails"
                    element={
                        <PrivateRoute>
                            <Emails />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/feedback"
                    element={
                        <PrivateRoute>
                            <Feedback />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/telegram-chat"
                    element={
                        <PrivateRoute>
                            <TelegramChat />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

export default Router;
